export enum CompanyTypeEnumFR {
	SAS = 'SAS',
	SAS_CAP_VARIABLE = 'SAS_CAP_VARIABLE',
	SARL = 'SARL',
	SASU = 'SASU',
	SCOP_ARL = 'SCOP_ARL',
	SCIC_ARL = 'SCIC_ARL',
	SA = 'SA',
	SCCV = 'SCCV',
	SNC = 'SNC',
	EURL = 'EURL',
	SCA = 'SCA',
	SCS = 'SCS',
	SC = 'SC',
	SCI = 'SCI',
	SCOP_SA = 'SCOP_SA',
	SCIC_SA = 'SCIC_SA',
	SCPI = 'SCPI',
	FIP = 'FIP',
	GFI = 'GFI',
	GFF = 'GFF',
	AUTRE = 'AUTRE',
	INCONNU = 'INCONNU'
}

export enum CompanyTypeEnum {
	SAS = 'SAS',
	SAS_CAP_VARIABLE = 'SAS_CAP_VARIABLE',
	SARL = 'SARL',
	SASU = 'SASU',
	SCOP_ARL = 'SCOP_ARL',
	SCIC_ARL = 'SCIC_ARL',
	SA = 'SA',
	SCCV = 'SCCV',
	SNC = 'SNC',
	EURL = 'EURL',
	SCA = 'SCA',
	SCS = 'SCS',
	SC = 'SC',
	SCI = 'SCI',
	SCOP_SA = 'SCOP_SA',
	SCIC_SA = 'SCIC_SA',
	SCPI = 'SCPI',
	FIP = 'FIP',
	GFI = 'GFI',
	GFF = 'GFF',
	OTHERS = 'OTHERS',
	any = 'any'
}

export const translateCompanyType = (ct: CompanyTypeEnumFR): CompanyTypeEnum => {
	switch (ct) {
		case CompanyTypeEnumFR.SAS:
			return CompanyTypeEnum.SAS;
		case CompanyTypeEnumFR.SAS_CAP_VARIABLE:
			return CompanyTypeEnum.SAS_CAP_VARIABLE;
		case CompanyTypeEnumFR.SARL:
			return CompanyTypeEnum.SARL;
		case CompanyTypeEnumFR.SASU:
			return CompanyTypeEnum.SASU;
		case CompanyTypeEnumFR.SCOP_ARL:
			return CompanyTypeEnum.SCOP_ARL;
		case CompanyTypeEnumFR.SCIC_ARL:
			return CompanyTypeEnum.SCIC_ARL;
		case CompanyTypeEnumFR.SA:
			return CompanyTypeEnum.SA;
		case CompanyTypeEnumFR.SCCV:
			return CompanyTypeEnum.SCCV;
		case CompanyTypeEnumFR.SNC:
			return CompanyTypeEnum.SNC;
		case CompanyTypeEnumFR.EURL:
			return CompanyTypeEnum.EURL;
		case CompanyTypeEnumFR.SCA:
			return CompanyTypeEnum.SCA;
		case CompanyTypeEnumFR.SCS:
			return CompanyTypeEnum.SCS;
		case CompanyTypeEnumFR.SC:
			return CompanyTypeEnum.SC;
		case CompanyTypeEnumFR.SCI:
			return CompanyTypeEnum.SCI;
		case CompanyTypeEnumFR.SCOP_SA:
			return CompanyTypeEnum.SCOP_SA;
		case CompanyTypeEnumFR.SCIC_SA:
			return CompanyTypeEnum.SCIC_SA;
		case CompanyTypeEnumFR.SCPI:
			return CompanyTypeEnum.SCPI;
		case CompanyTypeEnumFR.FIP:
			return CompanyTypeEnum.FIP;
		case CompanyTypeEnumFR.GFI:
			return CompanyTypeEnum.GFI;
		case CompanyTypeEnumFR.GFF:
			return CompanyTypeEnum.GFF;
		case CompanyTypeEnumFR.AUTRE:
			return CompanyTypeEnum.OTHERS;
		case CompanyTypeEnumFR.INCONNU:
			return CompanyTypeEnum.any;
	}
};

export const getCompanyTypeEnumDetailValue = (
	ct: CompanyTypeEnumFR,
	$t: (_: string) => string
): string => {
	return $t(`companyTypeDetail.${ct}`);
};
